export default {
    "['ImageResponse', 'ai.msg.domain.responses.core.Image']": 'IMAGE',
    "['VideoResponse', 'ai.msg.domain.responses.core.Video']": 'VIDEO'
}